export default __webpack_public_path__ + "static/garden_design33-a6ea6988d89b951c6ca27377dc5eae2b.webp";